import { useState, useEffect } from 'react';
import { enforceSession } from '../utils';

// How often (ms) to re-check with the server whether this device's session
// is still valid. Used to support force-logout from all devices.
const SESSION_CHECK_INTERVAL = 30000;

export default function useAuthListener() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('authUser')));

  useEffect(() => {
    // Check localStorage for user on mount
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    if (authUser) {
      setUser(authUser);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;

    // If the server reports the session is invalid (account force-logged-out),
    // clear local auth data and drop the user so the app redirects to sign-in.
    const check = async () => {
      const stillLoggedIn = await enforceSession();
      if (!cancelled && !stillLoggedIn) {
        setUser(null);
      }
    };

    // Run immediately on mount, then poll and re-check when the tab regains focus.
    check();
    const intervalId = setInterval(check, SESSION_CHECK_INTERVAL);
    window.addEventListener('focus', check);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      window.removeEventListener('focus', check);
    };
  }, []);

  return { user };
}
